'use client';
import React from 'react';
import { Summary } from './Summary';
import {
  ComponentSummaryCards,
  ComponentProductMetadata,
} from '$/(cms)/_modules/cmsService/types';
type SummaryCardsProps = {
  summaryConfig: ComponentSummaryCards;
  metadata?: ComponentProductMetadata;
};

const SummaryCards: React.FC<SummaryCardsProps> = ({
  metadata,
  summaryConfig,
}) => {
  const productCard = metadata?.product_card ?? [];
  const { titleReq, collapsible, collapsed_default, listType } = summaryConfig;

  const items = productCard
    .filter((p) => p.visible)
    .map((p) => ({
      id: p?.productBlock?.product?.uid,
      title: p?.productBlock?.product?.product_name,
      description: `${p?.productBlock?.text_tag}`,
      anchorId: `anchor-card-${p?.productBlock?.product?.uid}`,
      visibleMobile: p.visible_mobile,
    }));

  return (
    <Summary
      title={titleReq ?? ''}
      collapsible={collapsible}
      collapsedDefault={collapsed_default}
      listType={listType}
      items={items}
    />
  );
};

export default SummaryCards;
